import { createContext } from "react";
import { ActualFundType, Fund } from "@constants/funds-data";

export type BookmarksContextType = {
  bookmarks: ActualFundType["name"][];
  funds: ActualFundType[];
  topChangeDaily: ActualFundType[];
  topInflow: ActualFundType[];
  topOutflow: ActualFundType[];
  isFundsLoading: boolean;
  handleBookmark: (fund: ActualFundType["name"]) => void;
};

export const BookmarksContext = createContext(
  null as unknown as BookmarksContextType,
);
